import { UiThemeBlueColor } from "../utils/constants";

export const PopupComponent = ({
  label,
  moduleTitle,
  positivebtnLabel,
  minWidth,
  children,
}) => (
  <>
    <button
      type="button"
      class="btn btn-primary"
      style={{ backgroundColor: UiThemeBlueColor, color: "white", margin:0 }}
      data-toggle="modal"
      data-target="#exampleModal"
    >
      {label}
    </button>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style={{ minWidth }}>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {moduleTitle}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">{children}</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            {positivebtnLabel && (
              <button type="button" class="btn btn-primary">
                {positivebtnLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  </>
);
